import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterLink } from '@angular/router';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-skip-link',
  imports: [RouterLink],
  templateUrl: './skip-link.component.html',
  styleUrl: './skip-link.component.css',
})
export class SkipLinkComponent implements OnInit, OnDestroy {
  subs = new SubSink();
  skipLinkPath = '';

  @Input() text = 'Skip to main content';
  @Input() fragment = 'maincontent';

  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.checkIfFragmentInUrl();
  }

  checkIfFragmentInUrl() {
    this.subs.add(
      this._route.fragment.subscribe((fragment) => {
        if (fragment) {
          this.setSkipLink(fragment);
        } else {
          this.setSkipLink(null);
        }
      }),
    );
  }

  setSkipLink(fragment: string | null) {
    this.subs.add(
      this._router.events.subscribe((endNav) => {
        if (endNav instanceof NavigationEnd) {
          if (endNav.url != '') {
            if (fragment) {
              const element: HTMLElement | null = document.getElementById('maincontent');
              if (element) {
                element.setAttribute('tabindex', '-1');
                element.focus();
              }
              return (this.skipLinkPath = endNav.url.replace(`#${fragment}`, ''));
            } else {
              return (this.skipLinkPath = endNav.url);
            }
          }
          return;
        }
        return;
      }),
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
